import React, {Component} from 'react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { blue } from '@material-ui/core/colors';
import Grid from '@material-ui/core/Grid';
import logo from '../icons/newlogo.png'
import doctor from './images/doc01.jpg';
import BarMenu from './BarMenu.js';
import heart from '../icons/about_heart.svg';
import ysm from '../icons/YSM.gif';
import ynnh from '../icons/ynnh.png';
import doc_ong from './images/ong.jpg';
import doc_mathis from './images/mathis.jpg';
import doc_hermes from './images/hermes.jpg';
import StudentRoll from './StudentRoll.js';
import fda from './images/fda.png';
import dailymed from './images/dailymed.jpg';
import uptodate from './images/uptodate.png';
import how1 from './images/select.PNG';
import how2 from './images/compare.png';
import how3 from './images/edit.PNG';
import './css/appbar.css';
import decode from 'jwt-decode';

const ColorButton = withStyles(theme => ({
  root: {
    color: theme.palette.getContrastText(blue[600]),
    backgroundColor: blue[600],
    '&:hover': {
      backgroundColor: blue[700],
    },
  },
}))(Button);

export default class ButtonAppBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logged_in: localStorage.getItem('token') && !this.expired(localStorage.getItem('token')),
      username: '',
    };
    this.handle_logout = this.handle_logout.bind(this)
  }

  

  componentDidMount() {
    if (this.state.logged_in) {
      fetch('https://api.medbase.xyz/login/current_user/', {
        headers: {
          Authorization: `JWT ${localStorage.getItem('token')}`
        }
      })
        .then(res => res.json())
        .then(json => {
          this.setState({ username: json.username });
        });
    }
  }

  handle_logout = () => {
    localStorage.removeItem('token');
    this.setState({ logged_in: false, username: '' });
  };

  expired = (token) => {
    try {
      const decoded = decode(token);
      if (decoded.exp < Date.now() / 1000) { // Checking if token is expired. N
          return true;
      }
      else
          return false;
    }
    catch (err) {
        return false;
    }
  }



  render() {
    return (
      <div>
        <Grid container spacing={1} className="nav-bar">

          <Grid item xs={3} style={{marginLeft: "5%"}}>
            <Button>
              <img src={logo} className="button-logo" href=""/>
            </Button>
          </Grid>
          
          <Grid item xs={2}>
          </Grid>

          <Grid item xs={1} className="bar-buttons">
          <Button style={{marginTop: 20}}>
                <div >
                  <a href="#home" className="font-comfortaa color-black">Home</a>
                </div>
            </Button>
          </Grid>

          <Grid item xs={1} className="bar-buttons">
          <Button style={{marginTop: 20}}>
                <div >
                  <a href="#learn" className="font-comfortaa color-black">Learn</a>
                </div>
            </Button>
          </Grid>
          
          <Grid item xs={1} className="bar-buttons">
              <Button style={{marginTop: 20}}>
                <div>
                <a href="#about" className="font-comfortaa color-black">About</a>
                </div>
            </Button>
          </Grid>

          <Grid item xs={1} className="bar-buttons">
              <Button style={{marginTop: 20}}>
                <div>
                <a href="#team"  className="font-comfortaa color-black">Team</a>
                </div>
            </Button>
          </Grid>

          <Grid item xs={1} className="bar-buttons">
            <Button style={{marginTop: 20}}>
                <div>
                <a href="#contact"  className="font-comfortaa color-black">Contact</a>
                </div>
            </Button>
          </Grid>

          <Grid item xs={1} className="bar-buttons">
          {this.state.logged_in
           ? <div>
            {/* <Button variant="outlined" onClick={this.handle_logout} color="primary">
              <span style={{
                  "fontFamily" : "Helvetica Neue"
                }}>Log Out</span>
            </Button> */}
            <ColorButton style={{marginTop: 20, padding: "-10px"}} onClick={this.handle_logout}>
                <div className="font-comfortaa">
                  Log Out
                </div>
            </ColorButton>
            </div>
            : <ColorButton style={{marginTop: 20, padding: "-10px"}} href="login">
                <div className="font-comfortaa">
                  Login
                </div>
            </ColorButton>
          }
          </Grid>

          <Grid item xs={4} className="bar-menu">
          </Grid>

          <Grid item xs={1} style={{alignItems: "flex-end", marginTop: 15, marginRight: 15}}>
            <BarMenu />
          </Grid>
        </Grid>
        
        <scroll-container>
        <scroll-page id="home">
        <div className="home-screen">
        <Grid container>

          <Grid item xs={1} />

          <Grid item className="home-text">
            <Grid container spacing={3}>
              <Grid item xs={12} style={{paddingTop: 186, paddingLeft: "4%", paddingRight: "7%", marginLeft: "5%"}}>
                <div className="font-comfortaa text-main">
                  <p className="row1 color-black">Easily Compare</p>
                  <p className="row2 color-blue">Med Options</p>
                  <p className="row3 color-black">Side-By-Side</p>
                </div>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12} style={{paddingLeft: "8%", marginLeft: "5%"}}>
                <ColorButton variant="contained" size="large" color="primary" style={{marginLeft:"5%"}} href="psychiatry">
                  <div className="font-comfortaa">
                    Psychiatry
                  </div>
                </ColorButton>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={0.5} />

          <Grid item>
            <div>
              <img src={doctor} className="img-doc"/>
            </div>
          </Grid>
        </Grid>
      </div>
      </scroll-page>
      
      <scroll-page id="learn">

      <div className="howtouse-screen">
        <div className="howtouse-content">
          <Grid container spacing={2}>
            <Grid item xs={4} justify="space-evenly">
            <div className="how-section-content">
                <div className="how-section-title">
                  Choose From Over 80 Medications to Compare
                </div>

                <img src={how1} className="how-screenshots"/>
              </div>
            </Grid>

            <Grid item xs={4} justify="space-evenly">
              <div className="how-section-content">
                <div className="how-section-title">
                  Pictures, side effects, GoodRX prices, and more. All in one place
                </div>

                <img src={how2} className="how-screenshots"/>
              </div>
            
            </Grid>

            <Grid item xs={4} justify="space-evenly">
              <div className="how-section-content">

                <div className="how-section-title">
                  Edit and share custom patient instructions
                </div>

                <img src={how3} className="how-screenshots"/>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
      <div className="buffer" />
      </scroll-page>
      <scroll-page id="about">
        <div className="buffer" />
      </scroll-page>

      
      <div className="about-screen">
        <Grid container  alignItems="center" style={{paddingTop: 33, paddingBottom: 33}}>
          <Grid item xs={6.5} style={{paddingTop: 33, paddingBottom: 33, paddingLeft: "7%", paddingRight: "3%", marginLeft: "3%"}}>
            <div className="font-comfortaa about-text">
              <p className="row1 color-blue">Built by doctors</p>
              <p className="row2 color-blue">For doctors</p>
              <p className="row4 color-black" style={{marginTop: -40}}>
                Reducing the hassle of med comparison and improving patient education. 
              </p>
              <p className="row4 color-black">
                Created by physicians at the Yale School of Medicine and undergraduate developers. 
              </p>
              
              <p className="row4 color-black">
                Medication data from trusted sources, including:
              </p>
              <Grid container spacing={1}>
                <Grid item>
                  <img src={fda} className="sources-logo"></img>
                </Grid>
                <Grid item>
                  <img src={dailymed} className="sources-logo"></img>
                </Grid>
                <Grid item>
                  <img src={uptodate} className="sources-logo"></img>
                </Grid>
              </Grid>


            </div>
          </Grid>

          <Grid item xs={4} className="about-right">
            <img src={heart} className="about-heart" />
            
            <div className="margin-20" />

            <Grid container justify="center" alignItems="center">
              <Grid item>
                <img src={ysm} className="ysm-logo" />
              </Grid>
              <Grid item>
                <img src={ynnh} className="ynnh-logo" />        
              </Grid>
            </Grid>

            <Grid container justify="center" alignItems="center">
              <Grid item>
                <p className="text-supported">
                  Supported by physicians from Yale School of Medicine
                </p>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>

      <scroll-page id="team">
        <div className="buffer" />
      </scroll-page>

      <div className="team-screen">
        <div className="team-docs">
          <Grid container spacing={2} justify="center" alignItems="center">
            <Grid item xs={3}>
              <div className="doc-title font-comfortaa color-blue">
                <div> Project Lead/Inventor</div>
              </div>
              
              <img src={doc_ong} className="doc-img"/>

              <div className="doc-description font-comfortaa">
                <div className="doc-name">Shawn Ong, MD</div>
                <div className="doc-bg">Yale Internal Medicine Residency </div>
                <div className="doc-bg">Yale Clinical Informatics Fellow</div>
              </div>
            </Grid>

            <Grid item xs={3}>
              <div className="doc-title font-comfortaa color-blue">
                <div>Clinical Advisor</div>
              </div>
              
              <img src={doc_mathis} className="doc-img"/>

              <div className="doc-description font-comfortaa">
                <div className="doc-name">Walter Mathis, MD</div>
                <div className="doc-bg">Yale Assistant Professor of Psychiatry</div>
                <div className="doc-bg">Connecticut Mental Health Center</div>
              </div>
            </Grid>

            <Grid item xs={3}>
              <div className="doc-title font-comfortaa color-blue">
                <div> Clinical Advisor</div>
              </div>
              
              <img src={doc_hermes} className="doc-img"/>

              <div className="doc-description font-comfortaa">
                <div className="doc-name">Eric D.A. Hermes, MD</div>
                <div className="doc-bg">Yale Assistant Professor of Psychiatry</div>
                <div className="doc-bg">VA Connecticut Healthcare System</div>
              </div>
            </Grid>
          </Grid>
        </div>

        <div className="team-students">
          <div className="team-students-header font-comfortaa color-blue">
            Student Development Team
          </div>

          <div className="student-roll">
            <StudentRoll />
          </div>

          <div className="height-20" />

        </div>
      </div>
      
      <scroll-page id="contact">
        <div className="buffer" />
      </scroll-page>

      <div className="contact-screen">
        <div className="contact-content">
          <div className="contact-text">
            <div className="contact-1">Want to reach the Pillnotes team?</div>
              
            <div className="contact-2">
              The best way to reach us is through the two emails below. You will receive a reply within 3 days.
            </div>
              
            <div className="height-20" />
            <div className="height-20" />
            <div className="height-20" />
            <div className="height-20" />
            <div className="height-20" />

            <div className="contact-title">
              Shawn Ong, MD.
            </div>

            <div className="contact-email">
              shawn.ong@yale.edu
            </div>

            <div className="height-20" />

            <div className="contact-title">
              Jason Lu
            </div>

            <div className="contact-email">
              jason.lu@yale.edu
            </div>

          </div>
        </div>
      </div>

      <scroll-page id="copyright">
        <div className="buffer" />
      </scroll-page>

      <div className="copyright">
        <div className="copyright-content">
          <p>
            This information reflects the best available research studies.
            It was produced without funding from makers of psychiatric medications.
            The conversation aid was prepared by Yale School of Medicine physicians and the students of Yale Helix Group Undergraduate Developers
          </p>
          <p>
            LEGAL CONDITIONS AND TERMS OF USE APPLICABLE TO ALL USERS OF THIS SITE. 
            ANY USE OF THIS SITE CONSTITUTES YOUR AGREEMENT TO THESE TERMS AND CONDITIONS OF USE.
          </p>
          <p>
            ©Pillnote, Inc. Updated 2019. All rights reserved.
          </p>
        </div>
      </div>
      </scroll-container>
    </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/LandingPage/AppBar.js